import {
  FaYoutube,
  FaFacebook,
  FaBandcamp,
  FaSpotify,
  FaInstagram,
  FaItunes,
} from 'react-icons/fa'

const socialData = [
  {
    icon: <FaFacebook />,
    link: 'https://www.facebook.com/profile.php?id=61560240713461',
    id: '1',
  },
  // {
  //   icon: <FaYoutube />,
  //   link: 'https://www.youtube.com/@AshevilleMountainBoys',
  //   id: '2',
  // },
  // {
  //   icon: <FaInstagram />,
  //   link: 'https://www.instagram.com/ashevillemountainboys/',
  //   id: '3',
  // },
  {
    icon: <FaSpotify />,
    link: 'https://open.spotify.com/album/2dZnUysh8JMfyNiBg6h1C9',
    id: '4',
  },
  // {
  //   icon: <FaBandcamp />,
  //   link: 'https://ashevillemountainboys.bandcamp.com/merch',
  //   id: '5',
  // },
  {
    icon: <FaItunes />,
    link: 'https://music.apple.com/us/album/backstage-pass/6773667824',
    id: '6',
  },
]

export default socialData
